import { jsx as _jsx } from "react/jsx-runtime";
import { isRecordEmpty } from 'hx-util';
import { useEffect, useRef } from 'react';
export var VideoTrack = function (_a) {
    var track = _a.track, _b = _a.flipVideo, flipVideo = _b === void 0 ? false : _b;
    var ref = useRef(null);
    useEffect(function () {
        if (isRecordEmpty(track))
            return;
        var el = ref.current;
        track.attach(el);
        return function () {
            track.detach(el);
        };
    }, [track]);
    return (_jsx("video", { style: {
            height: '100%',
            maxWidth: '999999px',
            marginLeft: '50%',
            transform: "translate(-50%) ".concat(flipVideo ? 'scaleX(-1)' : ''),
        }, ref: ref }));
};
